var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6438 11.489V8.78213L16.1438 6.50963V13.7615L3.6438 11.489ZM11.1438 15.1353H6.1438V13.214L11.1438 14.1234V15.1353ZM16.1438 3.88525V5.239L3.42067 7.55213C2.82505 7.66025 2.3938 8.17775 2.3938 8.78213V11.489C2.3938 12.0934 2.82505 12.6109 3.42067 12.719L4.8938 12.9865V15.1353C4.8938 15.8246 5.45442 16.3853 6.1438 16.3853H11.1438C11.8332 16.3853 12.3938 15.8246 12.3938 15.1353V14.3503L16.1438 15.0321V16.3853H17.3938V3.88525H16.1438Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.8a4f25a29f6a79d7c3818b763e8ec0de.svg";
export { ForwardRef as ReactComponent };